/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { loadComponentLabelsData } from '@tcp/core/src/reduxStore/actions';
import { LABELS } from '@tcp/core/src/reduxStore/constants';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import {
  setCouponMergeError,
  setMaxItemError,
  setOOSError,
  setVMPItemError,
  setMaxItemErrorDisplayed,
  setBackPackDeletedError,
} from './BagPage.actions.util';

const getOrderDetails = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_ORDER_DETAILS, payload };
};

const getCartData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_CART_DATA, payload };
};
const getCachedCartData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA, payload };
};
const getNonCachedCartData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA, payload };
};
const getCartDataSequentially = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_CART_DATA_SEQUENTIALLY, payload };
};
const processMutationCachedData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.PROCESS_MUTATION_CACHED_DATA, payload };
};
const processMutationNonCachedData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.PROCESS_MUTATION_NON_CACHED_DATA, payload };
};
const setCachedDataLoader = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_CACHED_DATA_LOADER, payload };
};
const setCachedCartDataTTL = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_CACHED_CART_DATA_TTL, payload };
};
const setNonCachedCartDataTTL = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_NON_CACHED_CART_DATA_TTL, payload };
};
const clearCachedCartDataTTL = () => {
  return { type: BAGPAGE_CONSTANTS.CLEAR_CACHED_CART_DATA_TTL };
};
const clearNonCachedCartDataTTL = () => {
  return { type: BAGPAGE_CONSTANTS.CLEAR_NON_CACHED_CART_DATA_TTL };
};
const setNonCachedDataLoader = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_NON_CACHED_DATA_LOADER, payload };
};
const fetchCartData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.FETCH_CART_DATA, payload };
};
const getOrderDetailsComplete = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_COMPLETE, payload };
};

const getOrderDetailsCompleteApplePay = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_COMPLETE_APPLE_PAY, payload };
};

const getOrderDetailsPartial = (payload) => {
  return { type: BAGPAGE_CONSTANTS.GET_ORDER_DETAILS_PARTIAL, payload };
};
const updateCartCount = (payload) => {
  return { type: BAGPAGE_CONSTANTS.UPDATE_CART_COUNT, payload };
};
const setOrderId = (payload) => {
  return { type: BAGPAGE_CONSTANTS.CART_SET_ORDER_ID, payload };
};
const updateAirmilesData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.UPDATE_AIRMILES_DATA, payload };
};
const updatePayPalStatus = (payload) => {
  return { type: BAGPAGE_CONSTANTS.UPDATE_PAYPAL_STATUS, payload };
};
const startCheckout = (payload) => {
  return { type: BAGPAGE_CONSTANTS.START_BAG_CHECKOUT, payload };
};
const startPlccCheckout = (payload) => {
  return { type: BAGPAGE_CONSTANTS.START_PLCC_CHECKOUT, payload };
};
const setCouponsData = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_COUPONS_DATA, payload };
};

const setCouponsDataForHomeCarousel = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_COUPONS_DATA_FOR_HOME_CAROUSEL,
    payload,
  };
};

const setItemOOS = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_ITEM_OOS, payload };
};
const setItemUnavailable = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_ITEM_UNAVAILABLE, payload };
};
const setItemAvailable = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_ITEM_AVAILABLE, payload };
};
const setItems = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_ITEMS, payload };
};
const openCheckoutConfirmationModal = (payload = false) => {
  return {
    type: BAGPAGE_CONSTANTS.OPEN_CHECKOUT_CONFIRMATION_MODAL,
    payload,
  };
};
const closeCheckoutConfirmationModal = () => {
  return {
    type: BAGPAGE_CONSTANTS.CLOSE_CHECKOUT_CONFIRMATION_MODAL,
  };
};
const setBagPageError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_BAG_PAGE_ERRORS,
    payload,
  };
};
const fetchModuleX = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.FETCH_MODULEX_CONTENT,
  };
};
const setModuleX = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SET_MODULEX_CONTENT,
  };
};
const removeUnqualifiedItemsAndCheckout = (navigation, closeModal, navigationActions) => {
  return {
    type: BAGPAGE_CONSTANTS.REMOVE_UNQUALIFIED_AND_CHECKOUT,
    navigation,
    closeModal,
    navigationActions,
  };
};
const setCartItemsUpdating = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.CART_ITEMS_SET_UPDATING,
  };
};
const routeForCheckout = ({
  navigation,
  closeModal,
  navigationActions,
  recalc,
  checkoutStage,
  spcPage,
  fromLoginModal,
} = {}) => {
  return {
    type: BAGPAGE_CONSTANTS.ROUTE_FOR_CART_CHECKOUT,
    navigation,
    closeModal,
    navigationActions,
    recalc,
    checkoutStage,
    spcPage,
    fromLoginModal,
  };
};
const startPaypalCheckout = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.START_PAYPAL_CHECKOUT,
    payload,
  };
};
const startApplePayCheckout = () => {
  return {
    type: BAGPAGE_CONSTANTS.START_APPLE_PAY_CHECKOUT,
  };
};
const checkPaypalOOS = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.CHECK_PAYPAL_OOS,
    payload,
  };
};
const setPayPalModalActionOOS = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_PAYPAL_MODAL_ACTION_OOS,
    payload,
  };
};
const setApplePayModalActionOOS = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_APPLE_PAY_MODAL_ACTION_OOS,
    payload,
  };
};
const startPaypalNativeCheckout = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.START_PAYPAL_NATIVE_CHECKOUT,
    payload,
  };
};
const paypalAuthorization = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.AUTHORIZATION_PAYPAL_CHECKOUT,
    payload,
  };
};
const addItemToSflList = (payload, price) => {
  return {
    type: BAGPAGE_CONSTANTS.ADD_ITEM_SAVE_FOR_LATER,
    payload,
    price,
  };
};
const setCartItemsSFL = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.CART_ITEMS_SET_SFL,
  };
};
const setCartItemsSflError = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.CART_ITEMS_SET_SFL_ERROR,
  };
};
const getSflData = () => {
  return {
    type: BAGPAGE_CONSTANTS.GET_SFL_DATA,
  };
};
const setSflData = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SET_SFL_DATA,
  };
};
export const setSflId = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SET_SFL_LIST_ID,
  };
};
const setCartSflMerged = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SET_CART_SFL_MERGED,
  };
};
const setTranslatedSflData = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SET_TRANSLATED_SFL_DATA,
  };
};
const updateSflItem = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.UPDATE_SFL_ITEM,
  };
};
const startSflItemDelete = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SFL_ITEMS_DELETE,
    payload,
  };
};
const setSflItemDeleted = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SFL_ITEMS_SET_DELETED,
  };
};
const setBagItemDeleted = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.BAG_ITEMS_SET_DELETED,
  };
};
const setSflItemMovedToBag = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.SFL_ITEMS_MOVED_TO_BAG,
  };
};
const startSflDataMoveToBag = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SFL_ITEMS_MOVE_TO_BAG,
    payload,
  };
};
const openItemDeleteConfirmationModal = (payload) => {
  return { type: BAGPAGE_CONSTANTS.OPEN_ITEM_DELETE_CONFIRMATION_MODAL, payload };
};
const closeItemDeleteConfirmationModal = () => {
  return {
    type: BAGPAGE_CONSTANTS.CLOSE_ITEM_DELETE_CONFIRMATION_MODAL,
  };
};
const resetCartReducer = () => {
  return { type: BAGPAGE_CONSTANTS.RESET_CART_DATA };
};

const initActions = [(args) => loadComponentLabelsData({ category: LABELS.checkout, ...args })];

const getSetPayPalWebView = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.PAYPAL_WEBVIEW_ENABLE,
    payload,
  };
};

const isPaypalRenderDone = (payload) => {
  return { type: BAGPAGE_CONSTANTS.IS_PAYPAL_BUTTON_RENDER_DONE, payload };
};

const isPaypalLibraryAction = (payload) => {
  return { type: BAGPAGE_CONSTANTS.IS_PAYPAL_LIBRARY_RENDER_DONE, payload };
};

const setBagPageLoading = () => ({ type: BAGPAGE_CONSTANTS.FETCHING_CART_DATA });
const setNonCacheBagPageLoading = () => ({ type: BAGPAGE_CONSTANTS.FETCHING_NON_CACHE_DATA });
const setIsPaypalBtnHidden = (payload) => {
  return { type: BAGPAGE_CONSTANTS.PAYPAL_BUTTON_HIDDEN, payload };
};

const resetBagLoadedState = () => {
  return { type: BAGPAGE_CONSTANTS.RESET_BAG_LOADED_STATE };
};

const setBagLoadedState = () => {
  return { type: BAGPAGE_CONSTANTS.SET_BAG_LOADED_STATE };
};

const setBagPageIsRouting = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_BAG_PAGE_ROUTING,
    payload,
  };
};

const resetBagLoadingState = () => ({
  type: BAGPAGE_CONSTANTS.RESET_BAG_LOADING_STATE,
});

const resetNonCacheBagLoadingState = () => ({
  type: BAGPAGE_CONSTANTS.RESET_NON_CACHE_BAG_LOADING_STATE,
});

const setGetCartItemComplete = () => ({
  type: BAGPAGE_CONSTANTS.GET_CACHED_CART_DATA_COMPLETED,
});
const setGetCartDetailComplete = () => ({
  type: BAGPAGE_CONSTANTS.GET_NON_CACHED_CART_DATA_COMPLETED,
});
const updateAddressIds = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.UPDATE_ADDRESS_IDS,
    payload,
  };
};

const removeDeletedItem = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.REMOVE_DELETED_ITEM,
    payload,
  };
};

const addDeletedItemOnAPiFailure = () => {
  return {
    type: BAGPAGE_CONSTANTS.ADD_DELETED_ITEM_ON_API_FAILURE,
  };
};

const setIsGettingPaypalSettings = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.PAYPAL_SETTINGS_CALL_STATUS,
  };
};

const updateCartPriceData = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.UPDATE_CART_PRICE_DATA,
  };
};

const openApayUnqualifiedItemsModal = (payload) => {
  return { payload, type: BAGPAGE_CONSTANTS.OPEN_APAY_UNQUALIFIED_ITEMS_MODAL };
};

export const updateMiniBagFlag = (payload) => {
  return { type: BAGPAGE_CONSTANTS.UPDATE_MINIBAG_FLAG, payload };
};

export const setAddedToBagDataLocal = (payload) => ({
  type: BAGPAGE_CONSTANTS.UPDATE_CART_LOCAL_DATA,
  payload,
});

const updateOrderTypeData = (payload) => {
  return { payload, type: BAGPAGE_CONSTANTS.UPDATE_ORDERTYPE_DATA };
};

const setCartSupressOnBagUpdate = (payload) => {
  return { type: BAGPAGE_CONSTANTS.SET_CART_SUPRESS_BAG_UPDATE, payload };
};
export const resetCartCache = () => {
  return { type: BAGPAGE_CONSTANTS.RESET_CART_CACHE };
};

const setCartUpdateComplete = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.UPDATE_CART_COMPLETE,
    payload,
  };
};

export const setPaymentMethod = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_PAYMENT_METHOD,
    payload,
  };
};
export const setBagLoadingStatus = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_BAG_PAGE_LOADING_STATUS,
    payload,
  };
};

const setCartItemData = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.CART_ITEM_QUICK_UPDATE,
    payload,
  };
};

export const updatePriceDropItemValues = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.UPDATE_PRICE_DROP_VALUES,
    payload,
  };
};

export const updatePriceDropItemValuesInSfl = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.UPDATE_PRICE_DROP_VALUES_IN_SFL,
    payload,
  };
};

export const getVMPNavigationXHR = (payload) => {
  return {
    payload,
    type: BAGPAGE_CONSTANTS.VMP_NAVIGATION_XHR,
  };
};

const getEstimatedTax = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.GET_ESTIMATED_TAX,
    payload,
  };
};

const setEstimatedTax = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_ESTIMATED_TAX,
    payload,
  };
};

const setZipForTaxEstimation = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_ZIP_FOR_TAX,
    payload,
  };
};

const setZipCodeError = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_ZIP_CODE_ERROR,
    payload,
  };
};

const setAfterPayPopupOpen = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_AFTERPAY_OPEN,
    payload,
  };
};

const setBossCartAvailableFlag = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_BOSS_CART_AVAILABLE,
    payload,
  };
};

export const resetZipForTaxEstimation = () => {
  return {
    type: BAGPAGE_CONSTANTS.RESET_ZIP_FOR_TAX,
  };
};

export const setSubmitButtonState = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_SUBMIT_BUTTON_STATE,
    payload,
  };
};

export const resetTaxEstimationValue = () => {
  return {
    type: BAGPAGE_CONSTANTS.RESET_TAX,
  };
};
const isTotalCalculated = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.IS_TOTAL_CALCULATED,
    payload,
  };
};
export const couponCalculatetax = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.COUPON_CALCULATE_TAX,
    payload,
  };
};

const buttonSpinnerLoading = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.BUTTON_SPINNER_LOADER,
    payload,
  };
};
export const taxFromDefaultAddress = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.ESTIMATED_TAX_FROM_DEFAULT_ADDRESS,
    payload,
  };
};
export const nonCachedDataLoading = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.NON_CACHE_DATA_LOADING,
    payload,
  };
};

export const fetchInventoryDetails = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.FETCH_INVENTORY_DETAILS,
    payload,
  };
};

export const plccShippingAddressUpdate = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.PLCC_SHIPPING_ADDRESS_UPDATE,
    payload,
  };
};

export const isPlccIsShippingAddressModalOpen = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.IS_PLCC_IC_ADDRESS_MODAL_OPEN,
    payload,
  };
};
export const isPlccIsPickupModalOpen = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.IS_PLCC_IC_PICKUP_MODAL_OPEN,
    payload,
  };
};
const isFromEstimatedTaxForm = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.IS_FROM_ESTIMATED_TAX_FORM,
    payload,
  };
};

export const resetTaxFromDefaultAddress = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.RESET_ESTIMATED_TAX_FROM_DEFAULT_ADDRESS,
    payload,
  };
};

export const getUnqualifiedInventoryItem = () => {
  return {
    type: BAGPAGE_CONSTANTS.GET_UNQUALIFIED_ITEMS,
  };
};

export const setApplePayDefault = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SHOW_APPLE_PAY_DEFAULT,
    payload,
  };
};

export const startExpressCheckoutActn = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.START_AFTERPAY_EXPRESS_CHECKOUT,
    payload,
  };
};

export const saveShareCartActn = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SAVE_SHARE_CART,
    payload,
  };
};

export const saveShareCartErr = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SAVE_SHARE_CART_ERROR,
    payload,
  };
};

export const fetchShareCartErr = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.FETCH_SHARE_CART_ERROR,
    payload,
  };
};

export const fetchShareCartActn = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.FETCH_SHARE_CART,
    payload,
  };
};

export const setDefaultBanner = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_DEFAULT_BANNER,
    payload,
  };
};

export const removeCouponFailAction = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.REMOVE_COUPON_FAIL,
    payload,
  };
};

export const removeCouponSuccessAction = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.REMOVE_COUPON_SUCCESS,
    payload,
  };
};
export const togglePlccLoginModal = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.TOGGLE_PLCC_LOGIN_MODAL,
    payload,
  };
};

export const setQuickAddModalStateActn = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.TOGGLE_QUICK_ADD_MODAL,
    payload,
  };
};

export const setQuickAddModalRecsType = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.QUICK_ADD_MODAL_RECS_TYPE,
    payload,
  };
};

export const hasSFLApiCallCompleted = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.HAS_SFL_CALL_COMPLETED,
    payload,
  };
};

export const setIsMixedPaymentWithPaypal = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_IS_MIXED_PAYMENT_WITH_PAYPAL,
    payload,
  };
};

export const setAddToBagCallMade = (payload) => {
  return {
    type: BAGPAGE_CONSTANTS.SET_ADD_TO_BAG_CALL_MADE,
    payload,
  };
};

export default {
  getOrderDetails,
  getOrderDetailsComplete,
  getOrderDetailsCompleteApplePay,
  getOrderDetailsPartial,
  updatePayPalStatus,
  getCartData,
  getCachedCartData,
  getNonCachedCartData,
  getCartDataSequentially,
  fetchCartData,
  setCouponsData,
  setCouponsDataForHomeCarousel,
  setBagPageError,
  fetchModuleX,
  setModuleX,
  startCheckout,
  closeCheckoutConfirmationModal,
  removeUnqualifiedItemsAndCheckout,
  openCheckoutConfirmationModal,
  setItemOOS,
  paypalAuthorization,
  startPaypalCheckout,
  startApplePayCheckout,
  isPaypalRenderDone,
  isPaypalLibraryAction,
  startPaypalNativeCheckout,
  setCartItemsUpdating,
  setItemUnavailable,
  setItemAvailable,
  setItems,
  routeForCheckout,
  initActions,
  addItemToSflList,
  setCartItemsSFL,
  setCartItemsSflError,
  getSflData,
  setSflData,
  setCartSflMerged,
  openItemDeleteConfirmationModal,
  closeItemDeleteConfirmationModal,
  startSflItemDelete,
  startSflDataMoveToBag,
  setSflItemDeleted,
  setBagItemDeleted,
  resetBagLoadingState,
  resetCartReducer,
  getSetPayPalWebView,
  setBagPageLoading,
  setIsPaypalBtnHidden,
  resetBagLoadedState,
  setBagLoadedState,
  setTranslatedSflData,
  setBagPageIsRouting,
  updateSflItem,
  setSflItemMovedToBag,
  updateAirmilesData,
  updateAddressIds,
  checkPaypalOOS,
  setPayPalModalActionOOS,
  setApplePayModalActionOOS,
  updateCartCount,
  setOrderId,
  removeDeletedItem,
  addDeletedItemOnAPiFailure,
  setIsGettingPaypalSettings,
  updateCartPriceData,
  openApayUnqualifiedItemsModal,
  updateOrderTypeData,
  setCartSupressOnBagUpdate,
  setCouponMergeError,
  setMaxItemErrorDisplayed,
  setMaxItemError,
  setOOSError,
  setVMPItemError,
  setCachedDataLoader,
  setCachedCartDataTTL,
  setNonCachedCartDataTTL,
  setNonCachedDataLoader,
  clearCachedCartDataTTL,
  clearNonCachedCartDataTTL,
  processMutationCachedData,
  processMutationNonCachedData,
  resetCartCache,
  setNonCacheBagPageLoading,
  resetNonCacheBagLoadingState,
  setCartUpdateComplete,
  setGetCartItemComplete,
  setGetCartDetailComplete,
  setPaymentMethod,
  setCartItemData,
  getVMPNavigationXHR,
  getEstimatedTax,
  isFromEstimatedTaxForm,
  setEstimatedTax,
  setZipForTaxEstimation,
  setZipCodeError,
  isTotalCalculated,
  buttonSpinnerLoading,
  setBackPackDeletedError,
  startPlccCheckout,
  setApplePayDefault,
  startExpressCheckoutActn,
  setAfterPayPopupOpen,
  setBossCartAvailableFlag,
  setAddToBagCallMade,
};
